export default __webpack_public_path__ + "static/media/TVSapacheFamilia.02787ac9.webp";